<template>
  <div class="banner" ref="banner">
    <mt-swipe class="index-banner" :class="{ 'full': full }" v-bind:style="'width:' + 1200 + 'px;height:' + 460 + 'px'"
      :showIndicators="false">
      <mt-swipe-item v-for="(item, index) in items" :key="index">
        <div class="banner-wrapper">
          <img class="banner-image" v-lazy="item.adv_code" v-if='item.adv_code' @click="goAdUrl(item)">
        </div>
      </mt-swipe-item>
    </mt-swipe>
  </div>
</template>

<script>
export default {
  name: 'IndexBanner',
  data() {
    return {
      bannerwidth: 0,
      bannerheight: 0
    }
  },
  props: ['items', 'full'],
  computed: {
    isShowIndicators() {
      if (this.items && this.items.length > 1) {
        return true
      }
      return false
    }
  },
  methods: {
    goAdUrl(item) {
      // this.$router.push({ path: item.adv_typedate })
      if(item.adv_url != ''){
        this.$router.push({ path: item.adv_url })
      }
    }
  },
  mounted() {
    const Width = this.$refs.banner.clientWidth;  
    this.bannerwidth = Width
    this.bannerheight = Width * (300 / 702)
  }
}
</script>
<style lang="scss">
.index-banner {
  .mint-swipe-indicators {
    bottom: .4rem;

    .mint-swipe-indicator {
      opacity: 1;
      background: #D8D8D8;

      &.is-active {
        background: $primaryColor
      }
    }
  }
}
</style>
<style scoped lang="scss">
.index-banner {
  // padding-top: $modelSpace;
  // padding-bottom: $modelSpace;
  // background: #fff;

  .banner-wrapper {
    cursor: pointer;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;

    .banner-image {
      width: 100%;
      height: 100%;
      // border-radius: .4rem;
    }
  }
}

.index-banner.full {
  padding-top: 0;

  .banner-wrapper {
    left: 0;
    right: 0;

    .banner-image {
      border-radius: 0
    }
  }
}

.banner {
  width: 100%;
}
</style>
